export const CANADA_ISO = "CA";
export const US_ISO = "US";

export const NON_INTERNATIONAL_COUNTRIES_ISO = [CANADA_ISO, US_ISO];
